import React, { useEffect, useState, useContext } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import Sidebar from '../../components/DashboardSidebar';
import { Menu } from 'lucide-react';
import { AuthContext } from '../../context/AuthContext';
import { toast, ToastContainer } from 'react-toastify';
import { fetchWithAuth } from '../../utils/fetchWithAuth';
import 'react-toastify/dist/ReactToastify.css';


export default function PaymentMethodsPage() {
  const auth = useContext(AuthContext);
  
  const token = auth?.user?.token;
  const navigate = useNavigate();
  const location = useLocation();
  const [currency, setCurrency] = useState('USD'); // Default fallback
  const [isCancelling, setIsCancelling] = useState(false);
const [isSwitching, setIsSwitching] = useState(''); // store planId that is switching


  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [lang, setLang] = useState(auth?.user?.language || 'en');
  const [plans, setPlans] = useState([]);
  const [currentPlan, setCurrentPlan] = useState(null);
  const [billingCycle, setBillingCycle] = useState('monthly'); 

  
  

  async function handleManagePaymentMethods() {
    try {
      const res = await fetchWithAuth(`${process.env.REACT_APP_API_BASE}/api/payment/create-billing-portal-session`, {
        method: 'POST'
      });
  
      const data = await res.json();
  
      if (res.ok && data.url) {
        window.location.href = data.url;
      } else {
        toast.error(data.message || 'Failed to open Billing Portal');
      }
    } catch (err) {
      console.error('Billing portal error:', err);
      toast.error('Server error');
    }
  }
  

  return (
    <div className="flex min-h-screen bg-gray-100">
      <ToastContainer position="top-right" />
      {/* Sidebar */}
      <div className={`${sidebarOpen ? 'block' : 'hidden'} fixed md:relative md:block z-40 w-64`}>
        <Sidebar
          currentLang={lang}
          activeSection="account"
          onLangChange={setLang}
          onCloseMobile={() => setSidebarOpen(false)}
        />
      </div>

      {/* Main Content */}
      <div className="flex-1 p-6">
        {/* Mobile Hamburger */}
        <button onClick={() => setSidebarOpen(true)} className="block md:hidden mb-4">
          <Menu className="w-6 h-6 text-gray-700" />
        </button>

        <h2 className="text-3xl font-semibold mb-6 text-gray-800">Manage Payment Methods</h2>

        
{/* Payment Settings Section */}
<div className="mt-10">
  <h3 className="text-xl font-semibold text-gray-800 mb-4">
    Payment Settings
  </h3>

  <div className="bg-white p-6 rounded shadow">
    <p className="text-gray-600 text-sm mb-4">
      Manage your saved payment methods (credit/debit cards) securely via Stripe Billing Portal.
    </p>
    <button
      className="w-full bg-gray-800 text-white py-2 rounded hover:bg-gray-900 text-sm"
      onClick={handleManagePaymentMethods}
    >
      Manage Payment Methods
    </button>
  </div>
</div>        
      </div>
    </div>
  );
}
